var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6642 4.27559C15.3534 0.241469 9.64623 0.241469 8.33547 4.27559C7.95009 5.46167 6.8448 6.26471 5.59768 6.26471C1.35595 6.26471 -0.407671 11.6926 3.02396 14.1858C4.0329 14.9188 4.45508 16.2182 4.0697 17.4043C2.75894 21.4384 7.37616 24.793 10.8078 22.2998C11.8167 21.5667 13.1829 21.5667 14.1919 22.2998C17.6235 24.793 22.2407 21.4384 20.93 17.4043C20.5446 16.2182 20.9668 14.9188 21.9757 14.1858C25.4073 11.6926 23.6437 6.26471 19.402 6.26471C18.1549 6.26471 17.0496 5.46167 16.6642 4.27559ZM9.78953 7.64541C9.92242 7.25309 10.3482 7.04279 10.7405 7.17568C11.1328 7.30857 11.3431 7.73434 11.2102 8.12666C10.7791 9.39931 9.55645 10.2337 8.20741 10.2337C7.7932 10.2337 7.45741 9.89787 7.45741 9.48366C7.45741 9.06945 7.7932 8.73366 8.20741 8.73366C8.9469 8.73366 9.57523 8.27803 9.78953 7.64541Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5b4eada255c7375bdb48ef54c3fd8f07.svg";
export { ForwardRef as ReactComponent };